import { render } from "./RFlex.vue?vue&type=template&id=3999ed80"
import script from "./RFlex.vue?vue&type=script&lang=js"
export * from "./RFlex.vue?vue&type=script&lang=js"

import "./RFlex.vue?vue&type=style&index=0&id=3999ed80&lang=css"
script.render = render

export default script